import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import styles from './WrongWalletModal.module.scss';
import closeIcon from '../../assets/icons/btn-close-X.svg';
import { useTranslation } from 'react-i18next';

const WrongWalletModal = ({
    show,
    setShow,
    walletId,
}) => {
    const [t] = useTranslation();

    return (
        <div>
            <Modal
                show={show}
                className={styles.wrong_wallet_modal}
                centered contentClassName={styles.wrong_wallet_modalContent}
                dialogClassName={styles.wrong_wallet_modalDialog}
                onHide={() => setShow(false)}
            >
                <button className={styles.close_btn} onClick={() => setShow(false)}>
                    <img src={closeIcon} alt="close" />
                </button>
                <Modal.Body bsPrefix={styles.wrong_wallet_modalBody}>
                    {walletId
                        ? <div className={styles.wrong_wallet_title}>{t('WRONG_WALLET_PLEASE_SWITCH_LINKED_WALLET')} ({`${walletId?.substr(0,6)}...${walletId?.substr(walletId?.length - 4)}`})</div>
                        : <div>No linked wallet! Please link a wallet with this account first.</div>}
                    <div className={styles.btn}>
                        <Button variant='cdh-general-blue' onClick={()=> setShow(false)}>{t('CLOSE').toUpperCase()}</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export { WrongWalletModal };
